import React, { useState } from "react";
import { getAuth } from "firebase/auth";
import Header from "./Header";
import Footer from "./Footer";
import "./HomePage.css";
import { useNavigate } from "react-router";
import { Helmet } from "react-helmet";


<Helmet>
  <title>Get Affordable Family Insurance | Kora Insurance</title>
  <meta name="description" content="Protect your family with Kora's flexible and affordable insurance plans. Sign up in minutes and stay covered." />
  <meta name="keywords" content="Insurance Ghana, Family Insurance, Affordable Cover, Kora Insurance" />
  <meta name="robots" content="index, follow" />
  <link rel="canonical" href="https://korame.com.gh"/>
  {/* Open Graph tags */}
  <meta property="og:title" content="Best Online Insurance Platform" />
  <meta property="og:description" content="Compare and buy insurance plans with ease." />
  <meta property="og:url" content="https://korame.com.gh/" />
  <meta property="og:type" content="website" />
</Helmet>

const FAQItem = ({ question, answer }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="faq-item">
      <div
        className="faq-question"
        onClick={() => setIsOpen(!isOpen)}
        role="button"
        aria-expanded={isOpen}
        tabIndex={0}
      >
        {question}
        <span className={`faq-icon ${isOpen ? "open" : ""}`}>{isOpen ? "-" : "+"}</span>
      </div>
      <div className={`faq-answer ${isOpen ? "visible" : ""}`} style={{ maxHeight: isOpen ? "200px" : "0" }}>
        {answer}
      </div>
    </div>
  );
};

const HomePage = () => {
  const faqData = [
    { question: "What is an insurance policy?", answer: "An insurance policy is a legal contract between you and the insurance company that outlines the terms, conditions, and benefits of your coverage. It specifies the premium amounts, coverage period, benefit amount, and names of beneficiaries who will receive the financial support. Think of it as your guarantee of financial protection, clearly documented in writing." },
    { question: "What is Kora Insurance?", answer: "Kora Insurance, developed through a partnership between Summer Health Limited and Sanlam Insurance, is strategically designed to meet the health needs of impoverished and underserved populations in society." },
    { question: "What does the Kora Insurance policy offer?", answer: "Kora Insurance offers three key benefits: a funeral benefit, total permanent disability coverage, and a per-day hospitalization cover.	The funeral benefit and total permanent disability coverage apply to both the policyholder and the beneficiary.	The hospitalization cover is exclusively for the policyholder and does not extend to the beneficiary" },
    { question: "How is payment made?", answer: "Payment and benefits for Kora Insurance are processed through Mobile Money (MOMO) or Debit Card. These methods offer a convenient and accessible way for policyholders to manage their payments and receive benefits, aligning with modern financial practices in Ghana." },
    { question: "Why is life insurance necessary?", answer: "Life insurance provides financial security for your family's future. It ensures your loved ones have support for funeral expenses, ongoing living costs, mortgage payments, and other financial obligations while helping maintain their standard of living during a difficult time." },
    { question: "Does the policy have a waiting period before it is active?", answer: "Yes, there is a waiting period of three (3) months." },
    { question: "How does life insurance work?", answer: "Policyholders pay regular premiums, and in return, we provide a death benefit payout to designated beneficiaries when the unexpected occurs." }];

  const navigate = useNavigate();

  const handleAgentPortalClick = () => {
    const auth = getAuth();
    const user = auth.currentUser;

    if (user){
      navigate("/agent-dashboard");
    } else {
      navigate("/agent-login");
    }
  };

  return (
    <div className="home-page">
      <Header />
      <header className="hero">
        <div className="hero-wrapper">
          <div className="hero-content">
            <h1>Redefining the boundaries of financial security</h1>
            <p>Explore innovative life insurance solutions tailored for the African market. Protect your family's future today.</p>
            <div className="cta-buttons vertical-stack">
              <a href="/purchase" className="cta-button primary full-width">
                Visit Our Insurance Portal
              </a>
              <div className="cta-button-group-row">
                {/* <button className="cta-button secondary half-width" onClick={handleAgentPortalClick}>
                  Visit Agent Portal
                </button> */}
                
                <a href="/pricing" className="cta-button secondary half-width">
                  Learn More
                </a>
              </div>
            </div>
          </div>
        </div>
      </header>
      <section className="faq-section">
        <div className="container">
          <h2>Frequently Asked Questions</h2>
          <div className="faq-container">
            {faqData.map((item, index) => (
              <FAQItem key={index} question={item.question} answer={item.answer} />
            ))}
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default HomePage;
